import ls from "../../../common/helpers/localStorageActions";

export const MAX_TOTAL_RESULTS = 2000;

const shouldShowTags = ls.getPublicationsShowTags();
const shouldShowContributions = ls.getPublicationsShowContr();
const shouldShowAbstract = ls.getPublicationsShowAbstract();

const getDefaultIfNull = (val, defaultVal) => {
  if (val === null) {
    return defaultVal;
  }
  return val;
};

export const labels = {
  shouldShowTags: "Show AI Tags",
  shouldShowContributions: "Show Contributions",
  shouldShowAbstract: "Show Abstract",
};

export const initialConf = {
  shouldShowTags: getDefaultIfNull(shouldShowTags, true),
  shouldShowContributions: getDefaultIfNull(shouldShowContributions, true),
  shouldShowAbstract: getDefaultIfNull(shouldShowAbstract, true),
};
